import { appSettings } from '@/settings/app-settings';

import createHttpClient from './http-client';

const httpClient = createHttpClient(appSettings.api.ORDER_MANAGER_URL || '');

export async function getOrders(api: any, limit: number, skip: number) {
  try {
    const response = await httpClient.get(`/order?limit=${limit}&skip=${skip}`);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE GETTING ORDERS : ', error.message);
    throw error;
  }
}

export async function getOrderById(api: any, id: any) {
  try {
    const response = await httpClient.get(`/order/${id}`);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE GETTING ORDER BY ID : ', error.message);
    throw error;
  }
}

export async function fetchAllOrdersOfProducts(params: any) {
  try {
    const response = await httpClient.get(`/order/allOrders/product`, { params });
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE Featching orders : ', error.message);
    throw error;
  }
}

export async function DownloadOrdersOfProduct(productId: string, params: any) {
  try {
    const response = await httpClient.get(`/line-items/downloadLineItems/${productId}`, { params });
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE Downloading orders : ', error.message);

    throw error;
  }
}

export async function fetchAllOrdersForProducts(productId: string, params: any) {
  try {
    const response = await httpClient.get(`/order/product/${productId}`, { params });
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE Featching orders : ', error.message);
    throw error;
  }
}

export async function createUserProfileAddress(address: any) {
  try {
    const response = await httpClient.post(`/user-profile/address/`, address);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE Creating User Profile Address : ', error.message);
    throw error;
  }
}

export async function createParticipantDetail(details: any) {
  try {
    const response = await httpClient.post(`/user-profile/participant`, details);
    return response?.data;
  } catch (error: any) {
    console.log('Error while create participant details');
    throw error;
  }
}

export async function createUserProfileBusiness(business: any) {
  try {
    const response = await httpClient.post(`/user-profile/business`, business);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE Creating User Profile Address : ', error.message);
    throw error;
  }
}

export async function getUserProfileAddresses() {
  try {
    const response = await httpClient.get(`/user-profile/addresses/`);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE fetching User Profile Addresses : ', error.message);
    throw error;
  }
}

export async function getUserProfileParticipants() {
  try {
    const response = await httpClient.get(`/user-profile/participants`);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE fetching User Profile participants : ', error.message);
    throw error;
  }
}

export async function getUserProfileBusiness() {
  try {
    const response = await httpClient.get(`/user-profile/businesses`);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE fetching User Profile business : ', error.message);
    throw error;
  }
}

export async function updateProfileAddress(id: string, address: any) {
  try {
    const response = await httpClient.put(`/user-profile/address/${id}`, address);
    return response?.data;
  } catch (error: any) {
    console.log('Error while updating address');
    throw error;
  }
}

export async function updateParticipantDetail(id: string, details: any) {
  try {
    const response = await httpClient.put(`/user-profile/participant/${id}`, details);
    return response?.data;
  } catch (error: any) {
    console.log('Error while updating participant details');
    throw error;
  }
}

export async function updateProfileBusiness(id: string, business: any) {
  try {
    const response = await httpClient.put(`/user-profile/business/${id}`, business);
    return response?.data;
  } catch (error: any) {
    console.log('Error while updating business');
    throw error;
  }
}
